import React, { PropsWithChildren } from 'react';
import { RouteComponentProps } from 'react-router';
import { Props } from 'react-select';

interface ErrorPageProps extends RouteComponentProps {
  errorMessage: string;
  code: string;
}

class ErrorPage extends React.PureComponent<PropsWithChildren<ErrorPageProps>> {

  onReturn = () => {
    this.props.history.push('/dashboard');
  };

  render() {
    return (
      <>
        {this.props.children}
        <div className="d-flex flex-column align-items-center justify-content-center mt-3">
          <label className="error-message-code">{this.props.code}</label>
          <h1 className="mb-0">{this.props.errorMessage}</h1>
        </div>
      </>
    );
  }
}

export default ErrorPage;
